import Visit from '@/components/pages/visit/visit';
import EditVisit from '@/components/pages/visit/edit_visit';

import Detail from '@/components/pages/visit/visit_detail';
import EditVisitDetail from '@/components/pages/visit/edit_visit_detail';

export default [
    {
        name: 'visit',
        path: '/visit',
        component: Visit
    },
    {
        name: 'edit_visit',
        path: '/edit_visit',
        component: EditVisit
    },
    {
        name: 'plan_detail',
        path: '/visit/detail',
        component: Detail,
        props: true
    },
    {
        name: 'edit_visit_detail',
        path: '/visit/edit_visit_detail',
        component: EditVisitDetail,
        props: true
    },
];



// WEBPACK FOOTER //
// ./src/router/visit/visit.js